import { useLanguage } from "@/contexts/LanguageContext";
import { Calendar, CalendarDays } from "lucide-react";
import type { DateSelectionMode } from "./hooks/useMultiDateSelection";

interface DateSelectionModeToggleProps {
  mode: DateSelectionMode;
  onModeChange: (mode: DateSelectionMode) => void;
}

const DateSelectionModeToggle = ({ mode, onModeChange }: DateSelectionModeToggleProps) => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const translations = {
    dateRange: isRTL ? 'نطاق التواريخ' : 'Date Range',
    specificDates: isRTL ? 'تواريخ محددة' : 'Specific Dates'
  };

  return (
    <div className="flex items-center justify-center gap-2 mb-4 [&>button]:flex-1 sm:[&>button]:flex-none [&>button]:min-h-11">
      <button
        type="button"
        onClick={() => onModeChange('range')}
        className={`
          flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all
          ${mode === 'range' 
            ? 'bg-primary text-primary-foreground shadow-md' 
            : 'bg-muted text-muted-foreground hover:bg-muted/80'}
        `}
      >
        <Calendar className="h-4 w-4" />
        <span>{translations.dateRange}</span>
      </button>
      
      <button
        type="button"
        onClick={() => onModeChange('specific')}
        className={`
          flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all
          ${mode === 'specific' 
            ? 'bg-primary text-primary-foreground shadow-md' 
            : 'bg-muted text-muted-foreground hover:bg-muted/80'}
        `}
      >
        <CalendarDays className="h-4 w-4" />
        <span>{translations.specificDates}</span>
      </button>
    </div>
  );
};

export default DateSelectionModeToggle;
